module.exports = __webpack_public_path__ + "img/Web_Logo-Breidenbach_V2_ohne_de.77703716.png";